import { Flex, SectionTitle } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export type BaseItemSetInformationSectionProps = PropsWithChildren;

export default function BaseItemSetInformationSection(
  props: Readonly<BaseItemSetInformationSectionProps>,
) {
  const { children } = props;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Information' />
      {children}
    </Flex>
  );
}
